import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: "Aujourd'hui",
    [filter_yesterday]: 'Hier',
    [filter_this_week]: 'Cette semaine',
    [filter_last_week]: 'Semaine dernière',
    [filter_this_month]: 'Ce mois-ci',
    [filter_last_month]: 'Mois dernier',
    [filter_last_30_days]: '30 derniers jours',
    [filter_all]: 'Tout',
  },
};
